if(!customElements.get('util-accordion')) {
    class UtilAccordion extends HTMLElement {
      constructor() {
        super();
        var self = this;
        var expandMultiple = this.dataset.expandMultiple=='true';
        var reposition = this.dataset.reposition=='true';
        var repositionDelay = parseInt(this.dataset.repositionDelay);
        var filter = this.querySelector('.category-filter');
        this.accordions = this.querySelectorAll('.accordion');
        this.emitEvents = this.dataset.emitEvents === 'true';
        if (filter) {
          filter.addEventListener('change', ()=>{
            this.accordions.forEach(function(accordionItem){
              accordionItem.style.display = accordionItem.dataset.category==filter.value ? '' : 'none';
            });
          });
        }
        this.accordions.forEach(function(accordionItem) {
          var button = accordionItem.querySelector('button[aria-expanded]');
          var panel = accordionItem.querySelector('[role="region"]');
          button.addEventListener('click', function(event) {
            if (button.getAttribute('aria-expanded')=='true') {
              button.setAttribute('aria-expanded', 'false');
              accordionItem.classList.remove('open');
              $s.collapse(panel);
              if (self.emitEvents) {
                self.dispatchEvent(new CustomEvent('accordionCollapse', {detail: accordionItem}));
              }
            } else {
              button.setAttribute('aria-expanded', 'true');
              accordionItem.classList.add('open');
              $s.expand(panel);
              if (reposition && document.querySelector('body').classList.contains('is-mobile')) {
                setTimeout(() => {
                  $s.scrollToElement(this)
                }, repositionDelay)
              }
              if (!expandMultiple) {
                //close other panels
                var allButtonsExpanded = self.querySelectorAll((filter ? '[data-category="'+accordionItem.dataset.category+'"] ' : '') + 'button[aria-expanded="true"]');
                allButtonsExpanded.forEach(function(buttonExpanded) {
                  if (buttonExpanded!=button) {
                    var thisAccordion = buttonExpanded.closest('.accordion');
                    var thisPanel = thisAccordion.querySelector('[role="region"]');
                    buttonExpanded.setAttribute('aria-expanded', 'false');
                    thisAccordion.classList.remove('open');
                    $s.collapse(thisPanel);
                    if (self.emitEvents) {
                      self.dispatchEvent(new CustomEvent('accordionCollapse', {detail: thisAccordion}));
                    }
                  }
                })
                if (self.emitEvents) {
                  self.dispatchEvent(new CustomEvent('accordionExpand', {detail: accordionItem}));
                }
              }
            }
          });
        });
      }

    }
    customElements.define('util-accordion', UtilAccordion);
  
  }